import { Component, OnInit, ChangeDetectionStrategy, signal, computed, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import { TitleService } from '@services/title.service';
import { MetaService } from '@services/meta.service';
import { SeoUrl } from '@pipes/seo-url.pipe';
import { DecodeHtmlEntities } from '@pipes/decode-html-entities.pipe';
import { JobService } from '@services/job.service';
import { JobDetails } from '@interfaces/job-details.interface';
import { JobImageService } from '@services/job-image.service';
import { HeaderComponent } from '@components/header/header.component';
import { CopyrightComponent } from '@components/copyright/copyright.component';
import { FlagComponent } from '@components/flag/flag.component';
import { MapComponent } from '@components/map/map.component';

@Component({
    selector: 'app-job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink,
        TranslateDirective,
        DecodeHtmlEntities,
        HeaderComponent,
        CopyrightComponent,
        FlagComponent,
        MapComponent
    ]
})
export class JobDetailsComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly titleService = inject(TitleService);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);
  private readonly jobService = inject(JobService);
  private readonly jobImageService = inject(JobImageService);

  public jobDetails = signal<JobDetails | undefined>(undefined);
  public mapLocation = computed(() => {
    const location = this.jobDetails()?.location;
    return location ? `${location.city}, ${location.country.toUpperCase()}, ${location.postalCode}` : undefined;
  });

  async ngOnInit() {
    const seoPipe = new SeoUrl();
    this.route.params.subscribe(async (params: any) => {
      if (params.jobId) {
        const jobDetails = await this.jobService.getJobDetails(params.jobId);

        this.jobDetails.set(jobDetails);
        if (jobDetails) {
          this.titleService.setTitle(jobDetails.name);
          this.metaService.setMeta(
            jobDetails.name,
            '/job/' + seoPipe.transform(jobDetails.name) + '/' + params.jobId,
            this.jobImageService.getJobImage()
          );
        } else {
          this.router.navigate(['/404']);
        }
      }
    });
  }
}
